import { ANIMATION_IDENTIFIERS, DrawAnimationMechanicConfig } from '@Animation/types'
import { PLUS_3_CONFIG } from '../add-on-extra-draw/plus-3/config'
import { KenoSnakesNumberSelector } from './number-selector'
import { KenoSnakesNumber } from './number'
import { preLoadAssets } from './preload-assets'
import { KenoSnakesBackground } from './background'
import { KENO_SNAKES_MULTIPLIER_CONFIG } from '../add-on-multiplier/keno-snakes/config'
import { KenoSnakeTexturePreloader } from './texture-loader'
import { KENO_SNAKES_AUDIO_KEYS } from './constants'

export const KenoSnakesConfig: DrawAnimationMechanicConfig = {
  appSettings: {
    backgroundBaseColor: '#00222FFF',
    backgroundGlowColor: '#00B7FFFF',
    backgroundUrl: '/animations/keno-snakes/background.png',
  },
  numberSelector: KenoSnakesNumberSelector,
  background: KenoSnakesBackground,
  foreground: null,
  kenoNumber: KenoSnakesNumber,
  multiplierAnimationConfig: KENO_SNAKES_MULTIPLIER_CONFIG,
  assetPreloader: preLoadAssets,
  extraDrawAnimationConfig: PLUS_3_CONFIG(ANIMATION_IDENTIFIERS.CYBER_SNAKES),
  textureLoader: KenoSnakeTexturePreloader,
  audioKeys: KENO_SNAKES_AUDIO_KEYS
}
